import { render } from "./models.vue?vue&type=template&id=13c1ba3c"
import script from "./models.vue?vue&type=script&lang=js"
export * from "./models.vue?vue&type=script&lang=js"

import "./models.vue?vue&type=style&index=0&id=13c1ba3c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__